import Pachinko from "src/pachinko/PachinkoMatter";
import TitleWidget from "./TitleWidget";
import GitCalendar from "./GitCalendar";
import PublicChat from "./PublicChat";
import ContextWidget from "./ContextWidget";
import BadgesWidget from "./BadgesWidget";
import BadgesSideWidget from "./side widgets/BadgesSideWidget";
import DataVisWidget from "./DataVisWidget";
import ThreeDWidget from "./ThreeD";

export const ItemType = Object.freeze({
  PUZZLE: "puzzle",
  NORMAL: "normal",
  TEXT: "text",
  PACHINKO: "pachinko",
  CALENDAR: "calendar",
  CHAT: "chat",
  CONTEXT: "context",
  BADGES: "badges",
  DATAVIS: "datavis",
  THREED: "threed"
});


export const ItemTypeProperties = {
  puzzle: {minW: 3, minH: 4},
  badges: {minW: 2, minH: 3},
  text:{minW:3, minH:2 },
  context:{minW:4,minH: 3},
  datavis:{minW:2,minH: 2},
  calendar:{minW:3,minH: 1, maxW:6, maxH:2}
};



export const drawWidgets = (item, sidelist, containerRef) => {
  if(sidelist === true){
    return <div className="text-white">{item.type} {item.itemdata}</div>;
  }
  switch (item.type) {
    case ItemType.PACHINKO:
      return (
        <Pachinko />
      );
    case ItemType.CALENDAR:
      return (
        <GitCalendar/>
      );
    case ItemType.TEXT:
      return (
          <TitleWidget item={item} containerRef={containerRef}/>
      );
      case ItemType.CHAT:
      return (
          <PublicChat/>
      );
    case ItemType.CONTEXT: return <ContextWidget  containerRef={containerRef}/>
    case ItemType.BADGES: 
      if(sidelist === true) return <BadgesSideWidget />
    return <BadgesWidget containerRef={containerRef} />
    case ItemType.DATAVIS:
        return <DataVisWidget/>
    case ItemType.THREED:
        return <ThreeDWidget containerRef={containerRef}/>
    default:
      return <div>{item.itemdata}</div>;
  }
  
  
  //   function puzzleTile(item) {
  //     let bPosX,
  //       bPosY,
  //       pieceWidth,
  //       pieceHeight,
  //       xIndex,
  //       yIndex = 0;
  //     let pieceIndex = item.pieceIndex ?? item.x + item.y * gridCols;
  //     let backgroundSize;
  //     let test = 0;

  //     pieceWidth = gridWidth / gridCols;
  //     pieceHeight = gridHeight / gridRows;
  //     xIndex = pieceIndex % gridCols;
  //     yIndex = Math.floor(pieceIndex / gridCols);

  //     //This sets backgroundsize so that it shows the image in the correct scale with the grid background.
  //     if (imgAspect > containerAspect) {
  //       let offsetWidth = (gridHeight * imgAspect - gridWidth) / 2;
  //       backgroundSize = `${gridHeight * imgAspect}px ${gridHeight}px`;
  //       bPosX =
  //         offsetWidth +
  //         gridWidth / gridCols +
  //         (xIndex - 1) * pieceWidth -
  //         pieceInset * 2;
  //       bPosY =
  //         gridHeight / gridRows + (yIndex - 1) * pieceHeight - pieceInset * 2;
  //     } else {
  //       //width matches and crops a bit of the top and bottom of the page.
  //       let offsetHeight = (gridWidth / imgAspect - gridHeight) / 2;
  //       backgroundSize = `${gridWidth}px ${gridWidth / imgAspect}px`;
  //       bPosX = gridWidth / gridCols + (xIndex - 1) * pieceWidth + pieceInset;
  //       bPosY = offsetHeight + yIndex * pieceHeight + pieceInset;
  //     }

  //     return (
  //       <div
  //         className={`grid-stack-item-content ${"grid-stack-puzzle-piece"}`}
  //         style={{
  //           inset: `${pieceInset}px`,
  //           backgroundPositionX: `${-bPosX}px`,
  //           backgroundPositionY: `${-bPosY}px`,
  //           backgroundSize: backgroundSize,
  //         }}
  //       >
  //         {item.content}
  //       </div>
  //     );
  //   }
};